export const SIGN_OUT_USER = 'feature/Auth/SIGN_OUT_USER' as string;
export const SIGN_IN_USER = 'feature/Auth/SIGN_IN_USER' as string;
export const SIGN_UP_USER = 'feature/Auth/SIGN_UP_USER' as string;
export const GOOGLE_SIGN_IN = 'feature/Auth/GOOGLE_SIGN_IN' as string;
export const FACEBOOK_SIGN_IN = 'feature/Auth/FACEBOOK_SIGN_IN' as string;